(function () {
  var script = document.currentScript;
  var productHandle = script && script.dataset ? script.dataset.productHandle : '';
  var params = new URLSearchParams(window.location.search);
  var path = params.get('hh_path');
  var axis = params.get('hh_axis');
  var choiceId = params.get('hh_choice');
  var rank = Number(params.get('hh_rank'));
  var safeId = /^[a-z0-9_]{1,32}$/;
  var safeHandle = /^[a-z0-9-]{1,80}$/;

  if (params.get('hh_guide') !== '1') return;
  if (['self', 'gift', 'compare', 'first_time'].indexOf(path) === -1) return;
  if (!Number.isInteger(rank) || rank < 1 || rank > 7) return;
  if (path === 'first_time' && rank > 3) return;
  if (!safeHandle.test(productHandle)) return;
  if (path === 'gift') {
    if (['recipient', 'occasion'].indexOf(axis) === -1) return;
    if (!safeId.test(choiceId || '')) return;
  }
  if (
    typeof subscribe !== 'function' ||
    typeof PUB_SUB_EVENTS === 'undefined' ||
    !PUB_SUB_EVENTS.cartUpdate
  ) return;

  var captured = false;
  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    if (captured || !event || event.source !== 'product-form') return;
    if (!window.posthog || typeof window.posthog.capture !== 'function') return;

    var properties = {
      path: path,
      product_handle: productHandle,
      recommendation_rank: rank,
      instrumentation_source: 'theme_choice_guide_attribution'
    };
    if (path === 'gift') {
      properties.axis = axis;
      properties.choice_id = choiceId;
    }

    captured = true;
    window.posthog.capture(
      'choice_guide_attributed_add_to_cart',
      properties,
      { send_instantly: true }
    );
  });
})();
